<template>
  <span class="mai-badge" @click="$emit('clicked')">
    {{ badge.val }}
  </span>
</template>
<script>
  import VueScrollTo from 'vue-scrollto'
  export default {
    name: 'QuoteBadge',
    props: {
      badge: {
        required: true,
        type: Object
      }
    }
  }
</script>
<style>
  .mai-badge {
    background-color: #eee;
    color: #949292;
    cursor: pointer;
    padding: 3px 10px;
    border-radius: 12px;
    display: inline-block;
    margin: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/modules/quote/components/QuoteBadge.vue